// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1K_qV","fullView":"styles_fullView__iO1N3"};